import React from "react";
import { Button, Tooltip } from "flowbite-react";
import { Transaction } from "../../../domain/types/Transaction";
import {
  HiOutlineTag,
  HiOutlineDocumentDuplicate,
  HiOutlineExclamation,
} from "react-icons/hi";

interface TransactionActionsProps {
  transaction: Transaction;
  expanded?: boolean;
}

export const TransactionActions: React.FC<TransactionActionsProps> = ({
  transaction,
  expanded = false,
}) => {
  // temp just to make linter happy
  // remove when we start using transaction in the component
  if (!transaction) {
    return null;
  }
  const actions = [
    {
      icon: HiOutlineTag,
      label: "Categorize",
      onClick: () => {
        /* Category management */
      },
      tooltip: "Update category",
    },
    {
      icon: HiOutlineDocumentDuplicate,
      label: "Receipt",
      onClick: () => {
        /* Receipt management */
      },
      tooltip: "Attach receipt",
    },
    {
      icon: HiOutlineExclamation,
      label: "Report Issue",
      onClick: () => {
        /* Dispute flow */
      },
      tooltip: "Report issue",
    },
  ];

  if (expanded) {
    return (
      <div className="flex flex-wrap gap-2">
        {actions.map(({ icon: Icon, label, onClick }) => (
          <Button key={label} color="light" size="sm" onClick={onClick}>
            <Icon className="w-4 h-4 mr-2" />
            {label}
          </Button>
        ))}
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center gap-1">
      {actions.map(({ icon: Icon, onClick, tooltip }) => (
        <Tooltip key={tooltip} content={tooltip}>
          <button
            onClick={(e) => {
              e.stopPropagation();
              onClick();
            }}
            className="p-1 text-gray-500 hover:text-indigo-600 rounded-full hover:bg-gray-100"
          >
            <Icon className="w-4 h-4" />
          </button>
        </Tooltip>
      ))}
    </div>
  );
};
